import {
  type AggregationsMultiBucketAggregateBase,
  type SearchResponse,
} from "@elastic/elasticsearch/lib/api/types";
import { type ISSUES } from "~/types";

const removeUnclosedTags = (text: string): string => {
  if (!text) return;
  const div = document.createElement("div");
  div.innerHTML = text;

  return div.innerHTML.replace(/^[^<]*?(&gt;|>)/g, "");
};

export const buildHighlight = (highlight: Record<string, string[]>) => {
  return ["post_content", "post_content.exact"]
    .map((key) =>
      highlight?.[key]?.map((h) => removeUnclosedTags(h))?.join("...")
    )
    ?.filter((h) => h)
    .join("[...]");
};

export type ElasticSearchDocument = {
  post_id: 12545;
  ID: 12545;
  post_author: {
    raw: string;
    login: string;
    display_name: string;
    id: number;
  };
  post_date: string;
  post_date_gmt: string;
  post_title: string;
  post_excerpt: string;
  post_content_filtered: string;
  post_content: string;
  post_status: string;
  post_name: string;
  post_modified: string;
  post_modified_gmt: string;
  post_parent: number;
  post_type: string;
  post_mime_type: string;
  permalink: string;
  terms: {
    [key in ISSUES]: {
      term_id: number;
      slug: string;
      name: string;
      parent: number;
      term_taxonomy_id: number;
      term_order: number;
      facet: string;
    }[];
  };
  meta: {
    _no_login_field: [
      {
        value: string;
        raw: string;
        boolean: false;
      }
    ];
    autore: [
      {
        value: string;
        raw: string;
        boolean: boolean;
        date: string;
        datetime: string;
        time: string;
      }
    ];
    sottotitolo: [
      {
        value: "";
        raw: "";
        boolean: false;
      }
    ];
    audio: [
      {
        value: "";
        raw: "";
        boolean: false;
      }
    ];
    video: [
      {
        value: "";
        raw: "";
        boolean: false;
      }
    ];
  };
  date_terms: {
    year: number;
    month: number;
    week: number;
    dayofyear: number;
    day: number;
    dayofweek: number;
    dayofweek_iso: number;
    hour: number;
    minute: number;
    second: number;
    m: number;
  };
  comment_count: number;
  comment_status: string;
  ping_status: string;
  menu_order: number;
  guid: string;
  thumbnail: string;
};

export type ElasticSearchBucket = {
  key: string;
  doc_count: number;
}[];

export type ElasticSearchPostResult = SearchResponse<
  ElasticSearchDocument,
  Record<
    "category" | "multimedia" | "speciali",
    AggregationsMultiBucketAggregateBase
  >
>;
